import axios from '@liepin/cnpm-js-axios-fe';
import stringify from './qs/stringify';

class  ServiceError extends Error {
  constructor(code, message, response) {
    super(message)
    this.serviceError = true;
    this.code = code;
    this.response = response;
  }
}

// 创建实例
const instance = axios.create({
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  },
  baseURL: window.location.origin
});

// 处理函数不要是用Promise.reject拦截器中已经处理了
let handlers = { };
// request拦截器
instance.interceptors.request.use(function (config) {
  const contentType = config.headers['Content-Type'] || config.headers['content-type'];
  // config['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
  if (contentType === undefined) {
    // { a: ['b', 'c'] } => 'a=b&a=c'
    config.data = stringify( config.data, { arraryFormat: 'repeat' });
  }
  
  if (contentType && contentType.includes('application/json;')) {
    // note: 公司统一添加data做业务数据上传
    config.data = {
      data: config.data,
    };
  }
  return config;
});

// response拦截器
instance.interceptors.response.use(function (response) {
  const { data: { code, flag, msg } } = response;
  // 系统框架标志flag： 1成功 0 系统错误
  if (flag) {
    return response;
  }
  // 业务项目特殊代码全局处理
  if (handlers[code]) {
    return handlers[code](response.data);
  }
  if (handlers.default) {
    handlers.default(response.data);
  }
  return Promise.reject(new ServiceError(code, msg, response));
}, (error) => {
  // 公司底层框架我理解走不到这步
  return Promise.reject(error);
});

export const settingStatusHandler = (statusHandlers) => {
  handlers = { ...handlers, ...statusHandlers };
};
// eslint-disable-next-line prefer-destructuring
export const get = instance.get;
// eslint-disable-next-line prefer-destructuring
export const post = instance.post;